import { httpClient, postProcessUpsert } from '@genai/http-client';
import { CollectionId } from '../model';
import { FileStatus, StoredFile } from '../../file/model';

export const listFiles = (collectionId: CollectionId, isValid?: boolean, isCompleted?: boolean, equipmentType?: string) => {
  const requestParams = [];

  if (isValid !== undefined) {
    requestParams.push(`is_valid=${isValid}`);
  }

  if (isCompleted) {
    requestParams.push(`is_completed=${FileStatus.COMPLETED}`);
  }

  if (equipmentType !== undefined) {
    requestParams.push(`equipment_type=${equipmentType}`);
  }

  return httpClient(`/collections/${collectionId}/files?${requestParams.toString().replaceAll(',', '&')}`, {
    method: 'GET'
  }).then(postProcessUpsert<StoredFile[]>);
};
